<div class="modal-header">
  <h3 class="modal-title">
    {{ title }} <i (click)="cancel()" class="fa fa-times pull-right"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px" (click)="minimise = !minimise"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="divShadow1">
    <form class="form-horizontal" novalidate>
      @if (loading) {
<div class="modal-loader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      <div style="margin-left: 30px; margin-right: 30px; margin-bottom: 30px">
        @if (!loading) {
<div class="row">
          <div class="col-md-12">
            <div class="col-md-2">
              <label>Basket</label>
              <select id="sourceCodes-typ" class="form-control" name="sourceCodes-typ" 
                      [(ngModel)]="selectedSourceCode" required>
                <option value="">Select</option>
                @for (s of sourceData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-2">
              <label>Country</label>
              <select id="countryCodes-type" class="form-control" name="countryCodes-type" 
                      [(ngModel)]="selectedCountryCode" required>
                <option value="">Select</option>
                @for (s of countryData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-2">
              <label>Prorate COGS</label>
              <select id="prorate-type" class="form-control" name="prorate-type" 
                      [(ngModel)]="selectedProrateCOGS" required>
                <option value="">Select</option>
                @for (s of yesNoData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-2">
              <label>GP Variances</label>
              <select id="gpVariances-type" class="form-control" name="gpVariances-type" 
                      [(ngModel)]="selectedgpVariances" required>
                <option value="">Select</option>
                @for (s of gpVarianceData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-2">
              <label>SIC Code</label>
              <select id="sicCodes-type" class="form-control" name="sicCodes-type" 
                      [(ngModel)]="selectedSicCode" required>
                <option value="">Select</option>
                @for (s of sicCodeData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-1">
              <label>FSE</label>
              <select id="fse-type" class="form-control" name="fse-type" 
                      [(ngModel)]="selectedFSC" required>
                <option value="">Select</option>
                @for (s of yesNoData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>

            <div class="col-md-1">
              <label>Financial Corp</label>
              <select id="financial-type" class="form-control" name="financial-type" 
                      [(ngModel)]="selectedFinancialCorp" required>
                <option value="">Select</option>
                @for (s of yesNoData; track $index) {
<option [value]="s.CODE_KEY">{{ s.CODE_DESCRIPTION }}</option>
}
              </select>
            </div>
          </div>
        </div>
}

        <div class="row">
          <div class="col-md-12">
            <div class="table-scroll" style="padding-top: 0 !important;">
              <table class="main-table">
                <thead>
                  <tr>
                    <th class="sticky-col"></th>
                    <th class="sticky-col" style="text-align: center;">HO LEID</th>
                    <th class="sticky-col" style="text-align: center;">LEID</th>
                    <th class="sticky-col" style="text-align: center;">Tax Code</th>
                    <th class="sticky-col" style="text-align: center;">Reporting Period</th>
                    <th class="sticky-col" style="text-align: center;">ME Code</th>
                    <th class="sticky-col" style="text-align: center;">Basket</th>
                    <th class="sticky-col" style="text-align: center;">Country</th>
                    <th class="sticky-col" style="text-align: center;">Prorate COGS</th>
                    <th class="sticky-col" style="text-align: center;">GP Variances</th>
                    <th class="sticky-col" style="text-align: center;">SIC Code</th>
                    <th class="sticky-col" style="text-align: center;">FSE</th>
                    <th class="sticky-col" style="text-align: center;">Financial Corp</th>
                  </tr>
                </thead>
                <tbody>
                  @for (t of defaultsMultipleSelected; track trackByFn($index, t)) {
<tr>
                    <td><i class="fa fa-times" title="Remove Row" (click)="removeDefaultsRow(t)"></i></td>
                    <td>{{ t.HO_LEID }}</td>
                    <td>{{ t.LEID }}</td>
                    <td>{{ t.CDR_NO }}</td>
                    <td>{{ t.REPORTING_PERIOD }}</td>
                    <td>{{ t.ME_CODE }}</td>
                    <td>{{ t.BASKET_0 }}</td>
                    <td>{{ t.COUNTRY_0 }}</td>
                    <td>{{ t.PRORATE_COGS_0 }}</td>
                    <td>{{ t.GP_VARIANCES_0 }}</td>
                    <td>{{ t.SIC_CODES_0 }}</td>
                    <td>{{ t.FSE_0 }}</td>
                    <td>{{ t.FINANCIAL_CORP_0 }}</td>
                  </tr>
}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="isSaveClicked">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>

  <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>